//src/api/platform/contexts/routes.js
/*  Единственное место, где хранятся URL-ы, общие для Twitch / Kick / WTV …  */

import { PLATFORMS } from '../../../constants/platforms';

const byPlat = (p, path) => `/${p}/${path}`;

/* Шаблоны, одинаковые для всех slug-ов  */
const TEMPLATES = {
  bot: {
    status : (p)        => byPlat(p, 'bot-status'),
    start  : (p)        => byPlat(p, 'start-bot'),
    stop   : (p)        => byPlat(p, 'stop-bot'),
  },

  chat: {
    status : (p)        => byPlat(p, 'check-chat-status'),
    start  : (p)        => byPlat(p, 'start-chat'),
    stop   : (p)        => byPlat(p, 'stop-chat'),
  },
  quick: {
    list   : p       => byPlat(p, 'get-quick-replies'),
    add    : p       => byPlat(p, 'add-quick-reply'),
    order  : p       => byPlat(p, 'update-quick-replies-order'),
    send   : p       => byPlat(p, 'quick-send-message'),
    item   : (p, id) => byPlat(p, `quick-messages/${id}`),          // GET/PUT/DELETE
  },
  stream: {                   // info о живом стриме (Kick/WTV)
    info  : p       => byPlat(p, 'stream-info'),
    parse : p       => byPlat(p, 'parse-player'),
  },
  msgLists: {
    list : (p, chId)    => byPlat(p, `${chId}/message-lists`),
    add  : (p, chId)    => byPlat(p, `${chId}/message-lists`),
    del  : (p, id)      => byPlat(p, `message-lists/${id}`),
  },
  channel: {
    id    : p       => byPlat(p, 'get-channel-id'),
    accs  : p       => byPlat(p, 'get-accounts'),
  },
};

/* ---------- section → action → platform → fn ---------- */
export const ROUTES = Object.fromEntries(
  Object.entries(TEMPLATES).map(([section, acts]) => [
    section,
    Object.fromEntries(
      Object.entries(acts).map(([act, fn]) => [
        act,
        Object.fromEntries(
          PLATFORMS.map(({ id }) => [id, fn])
        ),
      ]),
    ),
  ]),
);

export const url = (section, action, platform, param) => {
  const fn = ROUTES?.[section]?.[action]?.[platform];
  if (!fn) throw new Error(`Unknown route ${section}.${action} for ${platform}`);
  return fn(platform, param);
};
